import {h, Fragment} from "preact"
export default function IconRemove () {
    return (
        <svg aria-hidden="true" role="presentation" class="icon icon-close" viewBox="0 0 32 32"><path class="stroke" d="M4.2,4.2,27.8,27.8m-23.6,0L27.8,4.2"></path></svg>
    )
}